export const STORAGE_KEY_BC_URL = "bcaddin_bc_url";
export const STORAGE_KEY_CLIENT_ID = "bcaddin_client_id";
export const STORAGE_KEY_COMPANY_ID = "bcaddin_company_id";
export const STORAGE_KEY_COMPANY_NM = "bcaddin_company_name";
export const STORAGE_KEY_COMPANY_ACRONYM = "bcaddin_company_acronym";
export const STORAGE_KEY_DEPARTMENT_SET_ENTRY_ID_FLT = "bcaddin_department_set_entry_id_flt";

export interface Settings {
  bcUrl: string;
  clientId: string;
  companyId: string;
  companyName: string;
  companyAcronym: string;
  departmentSetEntryIdFlt: string;
}

export interface RuntimeSettingInputs {
  useTaskpaneConfiguration: boolean;
  runtimeBcApiEndpoint: string;
  runtimeAzureAppClientId: string;
}

export function loadResolvedSettings(storage: Storage, runtime: RuntimeSettingInputs): Settings {
  const storedBcUrl = (storage.getItem(STORAGE_KEY_BC_URL) ?? "").trim();
  const storedClientId = (storage.getItem(STORAGE_KEY_CLIENT_ID) ?? "").trim();
  // bcUrl always prefers the stored value: in taskpane mode it's the user's manual entry;
  // in runtime mode it's the endpoint tied to the company the user selected (set at
  // selection time in companies.ts). The single runtime.runtimeBcApiEndpoint is only a
  // fallback for the pre-selection/legacy single-endpoint case.
  const bcUrl = storedBcUrl || runtime.runtimeBcApiEndpoint;
  const clientId = runtime.useTaskpaneConfiguration
    ? storedClientId || runtime.runtimeAzureAppClientId
    : runtime.runtimeAzureAppClientId || storedClientId;
  return {
    bcUrl,
    clientId,
    companyId: storage.getItem(STORAGE_KEY_COMPANY_ID) ?? "",
    companyName: storage.getItem(STORAGE_KEY_COMPANY_NM) ?? "",
    companyAcronym: storage.getItem(STORAGE_KEY_COMPANY_ACRONYM) ?? "",
    departmentSetEntryIdFlt: storage.getItem(STORAGE_KEY_DEPARTMENT_SET_ENTRY_ID_FLT) ?? "",
  };
}
